<template>
  <div>
    <el-main v-if="isPc" class="magazine">
      <el-row :gutter="20" class="magazine_list">
        <el-col :span="6" v-for="(item, index) in magazineList" :key="index">
          <div
            class="magazine_list_item little_hand"
            @click="toOutSideUrl(item.file_url)"
          >
            <el-image :src="$imgUrl + item.main_image" fit="cover"></el-image>
            <div class="title"><h3>{{ item.title }}</h3></div>
          </div>
        </el-col>
      </el-row>
    </el-main>
    <el-row v-else class="magazine_list m-magazine-list">
      <el-col :span="24" v-for="(item, index) in magazineList" :key="index">
        <div
          class="magazine_list_item little_hand"
          @click="toOutSideUrl(item.file_url)"
        >
          <el-image :src="$imgUrl + item.main_image" fit="cover"></el-image>
          <div class="title"><h3>{{ item.title }}</h3></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      magazineList: [],
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  methods: {
    // 获取杂志轮播列表
    async getMagazineList(context) {
      const { data: res } = await this.$http.get(
        `/api/v2/magazine/list?association_id=SZTX`
      );
      // // console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.magazineList = res.data.map((item) => {
        item.file_url = !/^http/.test(item.file_url)
          ? this.$imgUrl + item.file_url
          : item.file_url;
        return item;
      });
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    toOutSideUrl(file_url) {
      // console.log(file_url);
      window.open(file_url, "_blank");
    },
  },
  created() {
    this.getMagazineList();
  },
};
</script>

<style lang="less">
.magazine {
  width: 1028px !important;
}
.el-image {
  width: 100%;
}
.magazine_list_item {
  position: relative;
  display: flex;
  margin-top: 20px;
  height: 326px;
  border-radius: 8px;
  overflow: hidden;
  .title {
    position: absolute;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    color: #fff;
    box-sizing: border-box;
    font-size: 18px;
    padding: 12px 15px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    h3{
overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    }
    
  }
}
.m-magazine-list {
  padding: 0 20px;
  box-sizing: border-box;
  width: 100%;
  .magazine_list_item {
    height: 450px;
  }
}
</style>